module.exports = __webpack_public_path__ + "img/18-r.c45de160.png";